import React from 'react'
import Hospitality from '../Hospitality'
import Footer from '../Footer'

function HousingAndHospitality() {
    window.scrollTo(0,0);
    return (
        <>
            <Hospitality/>
            <Footer/>
        </>
    )
}

export default HousingAndHospitality

